export function restoreLegalScroll() {
    const source = window.location.href;
    const key = `mybake:scroll:${source}`;
    let target;
    try {
        const saved = sessionStorage.getItem(key);
        if (saved === null)
            return () => { };
        target = Number(saved);
        if (!Number.isFinite(target) || target < 0)
            return () => { };
    }
    catch (_a) {
        return () => { };
    }
    let frame = 0;
    let stopped = false;
    const observer = new ResizeObserver(() => schedule());
    const stop = () => { stopped = true; cancelAnimationFrame(frame); observer.disconnect(); };
    const apply = () => {
        if (stopped || window.location.href !== source)
            return stop();
        if (document.documentElement.scrollHeight - window.innerHeight < target)
            return;
        window.scrollTo({ top: target, left: 0, behavior: 'instant' });
        frame = requestAnimationFrame(() => {
            if (stopped || window.location.href !== source)
                return stop();
            if (Math.abs(window.scrollY - target) > 1)
                return schedule();
            try {
                sessionStorage.removeItem(key);
            }
            catch (_a) { }
            stop();
        });
    };
    function schedule() {
        if (stopped)
            return;
        cancelAnimationFrame(frame);
        // Next restores its own scroll after mounting the destination page.
        frame = requestAnimationFrame(() => { frame = requestAnimationFrame(apply); });
    }
    observer.observe(document.documentElement);
    observer.observe(document.body);
    schedule();
    return stop;
}
